module.exports = __webpack_public_path__ + "media/icons/menu-091292d3ad426fb7e7fdd4977e4e75b3.svg";